import axios from 'axios';
import { cloneDeep } from 'lodash';
import { refreshTokenMiddleware, tokenErrorHandler } from './refresh_token';
/* eslint-disable no-undef */
const { VUE_APP_API } = process.env;

if (!VUE_APP_API) {
	throw new Error('Missing api URLs');
}

const createVerifyApi = () => {
	const api = axios.create({
		baseURL: VUE_APP_API,
		headers: cloneDeep(axios.defaults.headers),
		withCredentials: true,
	});
	api.interceptors.request.use(
		async (config) => {
			const changedRequestConfig = await refreshTokenMiddleware(config);
			const updatedTokenHeaderInConfig = changedRequestConfig.headers.common.Authorization;
			if (updatedTokenHeaderInConfig) {
				// make sure we verify the new refreshed token - in the body sent
				const tokenHeaderParts = updatedTokenHeaderInConfig.split(' ');
				if (tokenHeaderParts.length === 2) {
					const validToken = tokenHeaderParts[1];
					// updating the /verify-token/ api body to be {token: <valid_token_updated_refresh_or_valid_to_begin_with>}
					changedRequestConfig.data = { token: validToken };
				}
			}
			return changedRequestConfig;
		},
		(err) => tokenErrorHandler({ err })
	);

	api.interceptors.response.use(
		(res) => {
			if (res) {
				const { results } = Object(res.data);
				return results || res.data;
			}
		},
		(err) => tokenErrorHandler({ err })
	);
	return api;
};

// public
export const verifyTokenApi = createVerifyApi();
export const loginWithToken = (token) => verifyTokenApi.post('verify-token/', { token });
